import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  ShieldCheck, Zap, Globe, BarChart3, Lock, Eye,
  ArrowRight, CheckCircle, ChevronRight
} from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import translations from '../i18n/translations';
import './Features.css';

 
const featureIcons = [
  <ShieldCheck size={24} />,
  <Eye size={24} />,
  <Globe size={24} />,
  <Zap size={24} />,
  <BarChart3 size={24} />,
  <Lock size={24} />,
];
const caseColors = ['#0077ff', '#00d4ff', '#00e676', '#ff6b6b', '#ffd600', '#ab47bc'];

export default function Features() { 
  const { lang } = useLang();
  const t = translations[lang].home; 

  return (
    <div className="Features">
       {/* Features */}
      <section className="features section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">{t.capabilitiesTag}</span>
            <h2 className="section-title">
              {t.capabilitiesTitle1}<br />
              <span className="gradient-text">{t.capabilitiesTitle2}</span>
            </h2>
            <p className="section-desc">{t.capabilitiesDesc}</p>
          </div>
          <div className="features__grid">
            {t.features.map((f, i) => (
              <div key={i} className="feature-card">
                <div className="feature-card__icon">{featureIcons[i]}</div>
                <h3 className="feature-card__title">{f.title}</h3>
                <p className="feature-card__desc">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
